var BaseViews = require('../../../base');

require('./shopping-cart-menu/shopping-cart-menu.scss');
var ShoppingCartMenu = BaseViews.LayoutView.extend({
    tagName: 'a',
    className: 'fmcy-shopping-cart-menu wpmenucart-contents',
    events: {
        click: 'goToCartClicked'
    },
    template: require('./shopping-cart-menu/shopping-cart-menu.html'),
    serializeData: function() {
        return {
            items: this.model.get('items'),
            totalAmount: this.model.get('totalAmount')
        };
    },
    onBeforeShow: function() {
        var hrefArray = window.location.href.split('/');
        this.$el.attr(
            'href',
            window.location.protocol + '//' + hrefArray[2] + '/cart'
        );
        this.$el.attr('title', 'View your shopping cart');
    },
    onShow: function() {
        window.gsap.to(this.$el, {
          color: '#D09F19',
          duration: 2,
        });
    }
});
module.exports = ShoppingCartMenu;



/** WEBPACK FOOTER **
 ** ./assets/js/common/menu/common/menu-item-prices/shopping-cart-menu.js
 **/